import { parseQueryStatNumber } from "./queryBuilder";
import { getNflAllTimeGreatsStat } from "../constants/nflAllTimeGreats";

export const getNflLeaderboardStatFormat = () => "count";

export const getNflLeaderboardStatValue = (player, stat) => {
  const config = getNflAllTimeGreatsStat(stat);
  return parseQueryStatNumber(player[config.statField]) ?? 0;
};

export const buildNflLeaderboardRows = (
  players = [],
  stat,
  { page = 0, pageSize = 25 } = {}
) =>
  players.map((player, index) => ({
    id: player.playerId || player._id || `row-${index}`,
    rank: page * pageSize + index + 1,
    playerId: player.playerId,
    playerName: player.name || player.bioData?.displayName || "Unknown",
    statValue: getNflLeaderboardStatValue(player, stat),
    position: player.position || player.bioData?.position || "—",
  }));
